import { createContext } from "react"
import { LessonFeedback } from "shared/types/submissionTypes"

export type LessonFeedbackContextType = {
    feedback: LessonFeedback
}

export const LessonFeedbackContext = createContext<LessonFeedbackContextType>({
    feedback: null
})
